import React from "react";

import portal_user_resources from "./portal_user_resources.png";
import portal_resources from "./portal_resources.png";

import add_resource_url from "./add_resource_url.png";
import add_resource_file from "./add_resource_file.png";

import create_resource_group from "./create_resource_group.png";

const EditingResources = () => (
  <div id="customisable_edit_resources" className="section">
    <h2>5.1 Edit Resources</h2>
    <p>
      Resources are available to the users in the "My Resources" section: Only resources applicable
      to the user and the courses they have been assigned are displayed.
    </p>
    <img src={portal_user_resources} alt="Edit Resources" className="center" />
    <p>
      These resources can be customised by selecting the <strong>"Edit Resources"</strong> option
      found under <strong>Configuration</strong> on the <strong>manage portal</strong> menu.
    </p>
    <img src={portal_resources} alt="Edit Resources" className="center" />
    <p>
      Resources available for your Portal are listed, they are organised into groups and denoted as
      being <strong>Standard</strong> resources (that get assigned to your portal by default),{" "}
      <strong>Additional</strong> resources (resources that are specific to your portal and have
      likely been added by an administrator for your portal) or <strong>Deprecated</strong>{" "}
      resources (resources which may now be superseded by newer versions). The resources are
      colour-coded, and a legend is shown at the top.
    </p>
    <h4>Edit a Resource</h4>
    <p>
      To edit a resource, click the <strong>Edit</strong> button. On the edit resource page that
      gets displayed, change the name, description and instructions as desired and then click the{" "}
      <strong>Update</strong> button.
    </p>
    <p>
      To change the order the resources appear in, click the <strong>Move Down/Up</strong> buttons.
      Alternatively resources may be dragged and dropped into their new order, updating the order
      upon each drop.
    </p>
    <h4>Add a Resource</h4>
    <p>
      To add a resources, click the <strong>Add Resource</strong> button.
    </p>
    <img src={add_resource_url} alt="Edit Resources" className="center" />
    <p>
      From the add a resource page, select the type; either URL or File - URLs are resources that
      are external to the ILX Portal, whilst Files are contained on the Portal itself, and so need
      to uploaded.
    </p>
    <p>When adding a File, the Add Resource section changes to look like this:</p>
    <img src={add_resource_file} alt="Edit Resources" className="center" />
    <p>
      Click the <strong>Browse</strong>&nbsp;button to select the file to be uploaded - it will need
      to have one of the following extensions: "jpeg", "jpg", "gif", "doc", "pdf", "docx", "xls",
      "xlsx", "ppt", "pptx", "zip" and also need to be less that 10&nbsp;MB in size.
    </p>
    <p>
      After entering all the relevant information, click the <strong>Create</strong>&nbsp;button,
      note that this may take a few minutes when adding large files.
    </p>
    <p>Once the resource has been added you will be redirected to the resources page.</p>
    <h4>Delete a Resource</h4>
    <p>
      A standard resource cannot be <strong>deleted</strong> from your portal. It instead can be be
      removed and hidden so that it will not appear as an available resource on the portal.
    </p>
    <p>
      To remove/hide a standard resource, click the <strong>Remove</strong> button. When a resource
      is hidden, it will appear greyed. To add a standard resource back, use the{" "}
      <strong>Restore</strong> button.
    </p>
    <p>
      If you have added a custom resource, then it can be deleted as its deletion will only affect
      your portal. To delete a custom resource click the <strong>Delete</strong> button. Please note
      that doing so will not allow it to be added back in at a later time.
    </p>
    <br />
    <h4>Resource Groups</h4>
    <p>
      On the portal "My Resources" page, each resource group is represented by a separate box.
      Adding a new resource group to your portal will therefore result in an extra tab appearing.
    </p>
    <p>
      Resource groups can be added, edited, removed and deleted in much the same way as resources.
    </p>
    <p>
      To add a resource group, go to the <strong>Create Group</strong> section towards the bottom of
      the resources page and enter a name for your group. Click <strong>Add</strong>, the new
      resource group will then appear above. Add resources to the group as before.
      <img src={create_resource_group} alt="Edit Resources" className="center" />
    </p>
    <p>
      To delete a customised resource group, click the <strong>Delete</strong> button.
    </p>
    <p>
      To remove a standard resource group, click the <strong>Remove</strong> button - again, only
      standard resource groups can be removed and re-added, customised resource groups are
      permanently deleted.
    </p>
  </div>
);

export default EditingResources;
